<template>
  <div class="body_area after_bg sm">

    <div class="block-header">
      <div class="container">
        <div class="row clearfix">
          <div class="col-lg-6 col-md-12">
            <h1 class="mb-1 mt-1">리스트</h1>
          </div>
        </div>
        <div class="bh_divider"></div>
        <div class="row clearfix">
          <div class="col-lg-12 col-md-12">
            <nav class="navbar navbar-expand-lg page_menu">
              <div class="collapse navbar-collapse" id="Blog_app" style="display: block;">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item "><a href="javascript:void(0);" class="nav-link"  @click="toLeadPage">리드</a></li>
                  <li class="nav-item active"><a href="javascript:void(0);" class="nav-link"  @click="toListPage">리스트</a></li>
                </ul>
                <div>
                  <button type="button" class="btn btn-secondary" @click="toAddListPage">리스트 추가</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>


    <div class="container">
      <div class="row clearfix">
        <div class="col-lg-12">
          <div class="card product_item_list">
            <div class="body">
              <div class="input-group search">
                <input type="text" class="form-control" placeholder="리스트명" v-model="keyword">
                <div class="input-group-append">
                  <span class="input-group-text" @click="getList"><i class="zmdi zmdi-search"></i></span>
                </div>
              </div>
              <div class="table-responsive" style="min-height: 520px;">
                <table class="table table-hover mb-0" style="text-align: center;">
                  <thead>
                  <tr>
                    <th>#</th>
                    <th >리스트명</th>
                    <th>리드갯수</th>
                    <th>생성일</th>
                    <!--                  <th>Amount</th>-->
                    <!--                  <th>Stock</th>-->
                    <th>설정</th>
                  </tr>
                  </thead>
                  <tbody v-if="groupList != null && groupList.length > 0">
                  <tr v-for="(group, index) in groupList" v-bind:key="index">
                    <td>{{ countingIndex(index)}}</td>
                    <td @click="toListLeadPage(group.leadGroupCode, group.leadGroupTitle)"><h5>{{group.leadGroupTitle}}</h5></td>
                    <td><span class="text-muted">{{group.leadCount}}</span></td>
                    <td><span class="text-muted">{{group.insertDt}}</span></td>
                    <!--                  <td>$16.00</td>-->
                    <!--                  <td><span class="col-green">In Stock</span></td>-->
                    <td>
                      <a href="javascript:void(0);" class="btn btn-sm btn-success" @click="editList(group.leadGroupCode)" style="color: white;"><font-awesome-icon :icon="faPen" /> </a>
                      <a href="javascript:void(0);" class="btn btn-sm btn-danger" @click="deleteList(group.leadGroupCode)"><font-awesome-icon :icon="faTrash" /> </a>
<!--                      <a href="javascript:void(0);" class="btn btn-sm btn-danger"><i class="zmdi zmdi-plus"></i></a>-->
                    </td>
                  </tr>

                  </tbody>
                  <tbody v-if="groupList == null || groupList.length == 0">
                  <tr >
                    <td colspan="5">리스트가 없습니다</td>
                  </tr>

                  </tbody>
                </table>
              </div>

              <div>
                <div class="justify-content-center">
                  <ul class="pagination pagination-primary" style="justify-content: center;">
                    <li class="page-item arrow-margin-left" v-if="pageNum > 1">
                      <a class="page-link" href="javascript:void(0);" aria-label="Previous" @click="changePage(1)">
                        <span aria-hidden="true"><i class="zmdi zmdi-chevron-left" aria-hidden="true"></i></span>
                      </a>
                    </li>

                    <li class="page-item" :class="{'active' : pageNum == num}" v-for="num in Math.ceil(totalCount/20)" :key="num" @click="changePage(num)"><a class="page-link" href="javascript:void(0);">{{num}}</a></li>

                    <li class="page-item arrow-margin-right" v-if="Math.ceil(totalCount/20) > 1">
                      <a class="page-link" href="javascript:void(0);" aria-label="Next" @click="changePage(pageNum+1)">
                        <span aria-hidden="true"><i class="zmdi zmdi-chevron-right" aria-hidden="true"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>

      <FooterView />
    </div>
  </div>
</template>


<script>
import FooterView from "@/components/common/FooterView";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import { fa } from "@fortawesome/free-regular-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default {
  name: 'ListListPage',
  components: {
    FooterView,
    FontAwesomeIcon
  },
  data() {
    return {
      groupList : null,

      keyword : null,
      pageNum : 1,
      totalCount : 0,

      faPen,
      faTrash,
    }
  },
  methods: {
    countingIndex(index){

      return this.totalCount - (this.pageNum -1)*20 - index
    },
    changePage(num){
      this.pageNum = num;

      this.getList();

    },
    deleteList(code){
      if(confirm("삭제하시겠습니까? ")){
        var param = {
          leadGroupCode : code,
          companyCode : this.$store.getters.getUserCode
        }
        console.log(param)

        this.api.removeList(param)
        .then((res)=>{

          if(this.utils.preApiHandle(res)) {
            console.log("list list res : ", res)
          }

          if(res.code == 0){
            alert("삭제되었습니다.")
            this.getList();
          } else {
            alert("오류가 발생했습니다.")
          }

        })

      }

    },
    editList(code){
      console.log(code)
      this.$router.push({name:'ListAddPage', params : {leadGroupCode : code}})
    },
    toAddListPage(){
      this.$router.push({name:'ListAddPage'})
    },
    toListLeadPage(code, title){
      this.$router.push({name:"LeadInListPage", params : {leadGroupCode : code, title : title}})
    },
    toLeadPage(){
      this.$router.push({name:"LeadListPage"})
    },
    toListPage(){
      this.$router.push({name:"ListListPage"})
    },
    getList(){
      var param = {
        companyCode : this.$store.getters.getUserCode,
        pageNum : "0",
        skipNum : this.pageNum - 1,
        keyword : this.keyword
      }

      this.api.getListList(param)
        .then((res)=>{
          console.log(res)

          if(this.utils.preApiHandle(res)) {
            console.log("list list res : ", res)
          }

          if(res.code == 0){
            this.groupList = res.listList;
            this.totalCount = res.totalCount;
          } else {
            alert("오류가 발생했습니다.")
          }
        })
    }
  },
  created() {
    console.log('ListListPage created')

    this.getList();

  },
  mounted() {
    console.log('ListListPage created')
  },
  beforeDestroy() {
    console.log('ListListPage beforeDestroy')
  }
}
</script>

